export const getEnvs = async () => {
	try {
		let response = await fetch("/config.json");
		response = await response.json();
		return response;
	} catch (err) {
		console.error(err);
	}
};
